import {RegionItemInfos} from "./RegionItemInfos"

/// <summary>
/// 行政区省信息
/// </summary>
export class  AreaInfo{

	constructor()
	{
		this.level = null;
		this.lonlat = null;
		this.name = null;
		this.points = null;
		this.type = null;
	}


	static GetAreaInfo(jsonObj)
		{	
			let curInfo=null;
			if(jsonObj==null)return curInfo;
			
			curInfo=new AreaInfo();
			curInfo.level =jsonObj.level;
			curInfo.lonlat=jsonObj.lonlat;
			curInfo.name=jsonObj.name;
			curInfo.points=RegionItemInfos.GetRegionItemInfos(jsonObj.points);
			curInfo.type=jsonObj.type;
			return curInfo;
		}

}//end AreaInfo

